<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">消息中心</span>
      <div class="handler-area">
        <div class="submit global_common_button_main btn" v-if="mode == 2" @click="submit()">
          <span>已读</span>
        </div>
        <div class="cancle global_common_button_goast btn" v-if="mode == 2" @click="changeMode(1)">
          <span>取消</span>
        </div>
        <div class="setting btn global_common_button_goast" v-if="mode == 1" @click="changeMode(2)">
          <span>编辑</span>
        </div>
      </div>
    </h2>
    <div class="list-content">
      <div class="list-area">
        <div class="messageList">
          <div class="nullData" v-if="messageCenterList.length == 0">
            <img :src="require('@/assets/img/messagenull.jpg')" alt="" />
            <p>暂无消息</p>
          </div>
          <ul>
            <li v-for="item in messageCenterList" :key="item.id" class="item">
              <div class="box">
                <el-checkbox
                  class="message_checkbox"
                  v-if="mode == 2"
                  :disabled="item.readStatus === 1"
                  :value="item.ifCheck"
                  @input="val => selectOne(item, val)"
                ></el-checkbox>
                <div class="messageMain" @click="handleMessage(item)">
                  <div class="circle" v-show="item.readStatus == 0"></div>
                  <div class="title">{{ item.msgTitle }}</div>
                  <div class="text">
                    <span class="content">
                      {{ item.msgContent }}
                    </span>
                    <span class="createTime">{{ renderTime(item.createTime) }}</span>
                  </div>
                </div>
                <div class="messageHander" @mouseenter="iconChange(1)" @mouseleave="iconChange(2)">
                  <img :src="icon" alt="" />
                </div>
              </div>
              <div class="line"></div>
            </li>
          </ul>
        </div>
        <div class="footer">
          <div class="selectAll" v-if="mode == 2">
            <el-checkbox v-model="checked" @change="selectAll">全选</el-checkbox>
          </div>
          <skinny-pagination
            :page-no="messageListParams.pageNo"
            @on-change="handleCurrentChange"
            :is-end="!hasNextPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { Pagination, Checkbox } from 'element-ui';
import Vue from 'vue';
import cB from '@/components/messageCenter/checkbox';
import SkinnyPagination from '@/components/skinnyPagination';
import { supervisionMessageAlert } from '@/util/notice';

Vue.use(Pagination);
Vue.use(Checkbox);
const icon1 = require('@/assets/img/btn_next_green_pre.png');
const icon2 = require('@/assets/img/btn_next_green_xuanfu.png');
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { cB, SkinnyPagination },
  data() {
    return {
      messageListParams: {
        pageNo: 1,
        pageSize: 10
      },
      icon: icon1,
      mode: 1,
      checked: false,
      selectList: [],
      hasNextPage: false,
      messageCenterList: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async submit() {
      // 已读消息
      console.log('## submit', this.selectList);
      const messageIds = this.messageCenterList
        .filter(o => o.ifCheck)
        .map(v => {
          return v.id;
        });

      if (!messageIds?.length) {
        this.$message.error('请选择消息');
        return;
      }

      try {
        let res = await Fetch.readSupervisionMessage({ messageIds });
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.mode = 1;
        this.clearSelectList();
        await this._messageCenterList();
      } catch (error) {
        throw error;
      }
    },
    clearSelectList() {
      this.checked = false;
    },
    selectOne(item, val) {
      // 单选
      item.ifCheck = val;
    },
    selectAll(value) {
      if (value === false) {
        this.messageCenterList = this.messageCenterList.map(o => {
          if (o.readStatus === 0) o.ifCheck = value;
          return o;
        });
      } else {
        this.messageCenterList = this.messageCenterList.map(o => {
          if (o.readStatus === 0) o.ifCheck = value;
          return o;
        });
      }
    },
    changeMode(m) {
      if (m == 1) {
        this.mode = 1;
        this.checked = false;
        this.messageCenterList = this.messageCenterList.map(o => {
          if (o.readStatus === 0) o.ifCheck = false;
          return o;
        });

        return;
      }
      this.mode = 2;
    },
    iconChange(t) {
      if (t == 1) {
        this.icon = icon2;
      } else {
        this.icon = icon1;
      }
    },
    handleCurrentChange(val) {
      this.messageListParams.pageNo = val;
      this._messageCenterList();
      this.clearSelectList();
    },
    init() {
      this._messageCenterList();
    },
    async _messageCenterList() {
      // 获取消息列表
      const params = {
        pageNo: this.messageListParams.pageNo,
        pageSize: this.messageListParams.pageSize
      };
      let res = await Fetch.getSupervisionMessageList({ ...params });
      this.hasNextPage = !(res?.data.length < this.messageListParams.pageSize);
      this.messageCenterList = res.data;

      //   [{
      //   'createTime': 1661578800000,
      //   'id': 133523,
      //   'messageDataList': [
      //     '{"classify":1,"storeNum":0,"registeredStoreNum":0,"unRegisteredStoreNum":0,"totalNum":0,"registeredNum":0,"toRegisteredNum":0,"unRegisteredNum":0}',
      //     '{"classify":2,"storeNum":0,"registeredStoreNum":0,"unRegisteredStoreNum":0,"totalNum":0,"registeredNum":0,"toRegisteredNum":0,"unRegisteredNum":0}',
      //     '{"classify":3,"storeNum":0,"registeredStoreNum":0,"unRegisteredStoreNum":0,"totalNum":0,"registeredNum":0,"toRegisteredNum":0,"unRegisteredNum":0}'
      //   ],
      //   'messageTime': 1661576400000,
      //   'msgContent': '您好，今日（截止13点）零售药店监管数据如下:——四类药品：销售药店共0家，0家完成登记，0家未完成登记；销售记录共0条，0条已登记，0条待登记；特殊药品：销售药店共0家，0家完成登记，0家未完成登记；销售记录共0条，0条已登记，0条待登记；处方药品：销售药店共0家，0家正常，0家存在异常；销售记录共0条，0条凭处方销售，0条未凭处方销售，0条待上传；请及时跟进处理。',
      //   'msgTitle': '当日数据',
      //   'msgType': 6,
      //   'readStatus': 0
      // }];
    },
    renderTime(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
    },
    async handleMessage(item) {
      await supervisionMessageAlert(item, () => {}, this._messageCenterList);
    }
  }
};
</script>
<style lang="scss" scoped>
.nullData {
  padding-top: 50px;
  img {
    display: block;
    width: 272px;
    margin: 0 auto;
  }
  p {
    text-align: center;
  }
}
.title-area {
  overflow: hidden;
  padding-bottom: 10px;

  .main-title {
    float: left;
    line-height: 40px;
  }
  .handler-area {
    overflow: hidden;
    .setting {
    }
    .add-story {
      // background: #ebb436;
      // &:hover {
      //   background: rgba(255, 195, 59, 1);
      // }
      // span {
      //   color: #fff;
      // }
    }
    .btn {
      width: 132px;
      height: 40px;
      float: right;
      line-height: 40px;
      text-align: center;
      margin-right: 16px;
      border-radius: 4px;
      cursor: pointer;
      span {
        font-size: 14px;
      }
    }
  }
  .cancle {
  }
  .submit {
  }
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  // padding: 16px;
  padding-bottom: 16px;
  min-height: 600px;
  .list-area {
    .messageList {
      min-height: 600px;
      padding-bottom: 16px;
      .item {
        cursor: pointer;
        &:hover {
          background: #fafafa;
        }

        padding: 15px 16px 0;
        // border-bottom: 1px solid #f2f2f2;
        .box {
          display: flex;
          justify-content: space-between;
        }
        .line {
          border-bottom: 1px solid #f2f2f2;
          padding-bottom: 15px;
        }
        .message_checkbox {
          margin-right: 18px;
        }
        .messageMain {
          position: relative;
          width: 100%;
          .circle {
            position: absolute;
            width: 8px;
            height: 8px;
            background: #e0514c;
            border-radius: 50%;
            left: -10px;
            top: 1px;
            border: 1px solid #fff;
          }
          .title {
            color: #242424;
            font-size: 16px;
            padding-bottom: 2px;
          }
          .text {
            font-size: 14px;
            color: #707070;
            .content {
            }
            .createTime {
              margin-left: 12px;
            }
          }
        }
        .messageHander {
          display: flex;
          align-items: center;
          &:hover {
            span {
              color: #4dd168;
            }
          }
          span {
            color: #1e8dff;
            font-size: 14px;
            cursor: pointer;
          }
          img {
            width: 6px;
            margin-left: 6px;
            position: relative;
            top: -1px;
          }
        }
      }
    }
    .footer {
      overflow: hidden;
      display: flex;
      justify-content: center;
      position: relative;
      .selectAll {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
      .sureJump {
        // float: left;
        width: 80px;
        height: 32px;
        // color: #1E8DFF;
        // background: #ffffff;
        // border: 1px solid #1E8DFF;
        border-radius: 3px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 22px;
      }
      .disabled_page {
        position: absolute;
        display: flex;
        align-items: center;
        right: 20px;
        top: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
